// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NqR7W","label":"styles_label__9IUMU"};